import React from "react";

// Numbered / labeled section overline in mono font.
export default function SectionLabel({ index, children, dark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="section-label">
      {index && (
        <span className="font-mono text-xs text-gema-red tracking-[0.2em]">{index}</span>
      )}
      <span className="h-px w-8 bg-gema-red" />
      <span
        className={`font-mono text-xs uppercase tracking-[0.25em] ${
          dark ? "text-white/60" : "text-black/50"
        }`}
      >
        {children}
      </span>
    </div>
  );
}
